import type { UserConsent } from './types'

export const cookieNames = {
  // Anonymous UUID used for segment
  anonymous_id: 'ajs_anonymous_id',
  // UUID used for split.io
  browser_id: '_gs_browser_id',
  // Coupon code. Needs to be passed on to the WBF and later to the backend.
  coupon: '_gs-coupon',
  // Deterimines the campaign which should be show in the WBF. Needs to be passed on to the WBF
  campaign: '_gs-campaign',

  // Contains the name of the referring person
  referrerName: '_gs-referrerName',

  // Referral code, needs to be passed on to the WBF
  referralCode: '_gs-referralToken',

  // Code which is used by financeAds to track conversions. Needs to be passed on to the WBF.
  fa_tracking_parameter: '_gs-conv-fa',

  // Code which is used by awin to track conversions. Needs to be passed on to the WBF.
  aw_tracking_parameter: '_gs-conv-aw',

  // Code which is used for generic conversion tracking. Needs to be passed on to the WBF.
  utm_source: '_gs-conversion-source-parameter',

  // Utm parameter which may be sent by a partner. It can be used in WBF tracking events
  utm_campaign: '_gs-conversion-campaign-parameter',

  // Utm parameter which may be sent by a partner. It can be used in WBF tracking events
  utm_medium: '_gs-conversion-medium-parameter',
} as const

export const COOKIES_CATEGORIES: Record<string, string[]> = {
  necessary_cookies: [
    cookieNames.referrerName,
    cookieNames.referralCode,
    cookieNames.coupon,
    cookieNames.browser_id,
    cookieNames.campaign,
    cookieNames.fa_tracking_parameter,
  ],
  functional_cookies: [],
  advertising_cookies: [
    cookieNames.aw_tracking_parameter,
    cookieNames.utm_campaign,
    cookieNames.utm_source,
    cookieNames.utm_medium,
  ],
}

export const getAllowedCookies = (userConsent: UserConsent) => {
  const cookieConsent = Object.keys(COOKIES_CATEGORIES).reduce((acc, cookie) => {
    if (userConsent[cookie]) {
      acc[cookie] = userConsent[cookie]
    }
    return acc
  }, {} as UserConsent)

  const allowedCookies = Object.keys(cookieConsent).reduce((acc, key) => {
    acc.push(...COOKIES_CATEGORIES[key])
    return acc
  }, [] as string[])

  return allowedCookies
}

export const isCookieAllowed = (cookieName: string, userConsent?: UserConsent) => {
  const cookieCategory = Object.keys(COOKIES_CATEGORIES).find((categoryKey) =>
    COOKIES_CATEGORIES[categoryKey].find((cookie) => cookie === cookieName)
  )

  if (!cookieCategory) {
    return false
  }
  return userConsent ? userConsent[cookieCategory] : false
}

export const isCookieNecessary = (cookieName: string) =>
  COOKIES_CATEGORIES.necessary_cookies.indexOf(cookieName) !== -1
